
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/design-process/done",
      function () {
        return require("private-next-pages/download/design-process/done/index.tsx");
      }
    ]);
  